import "./member.css";
import React, {useEffect, useMemo, useState} from "react";
import {ApiService} from "lib/http.service";
import {env, programUrlPrefix, resultsUrlPrefix} from "../../constants/global.vars";
import {CurrencyFormat, dateTimeFormat, mobileView, shareOnSocial} from "../../services/misc.functions";
import {
    getAvailableHippodromes,
    getBulletinCardId,
    getDailyRaces,
    getHippodromesMap,
    useAvailableHippodromes,
    useBulletinCardId,
    useHippodromesMap,
} from "features/bulletin/bulletin.store";
import {BettingTypesMap} from "features/core/definitions";
import {BettingTypeIds} from "features/core/definitions";
import {restoreMutualCoupon, showMutualReplayError} from "features/betslip/mutual.service";
import _ from "lodash";
import {FOBBetslip, isFobItemPlayable} from "features/betslip/fob.service";
import {modalServiceSubject} from "../../services/modal.service";
import {GetStablemateIcon} from "../betting/components/betting-datatable";
import {isMobile} from "../../App";
import {useLocation, useNavigate} from "react-router-dom";
import clockIcon from "../../assets/feather/clock.svg";
import paths from "../../paths";
import iconInfo from "../../assets/feather/info.svg";
import chevronDown from "../../assets/feather/chevron-down.svg";
import chevronUp from "../../assets/feather/chevron-up.svg";
import calculate from "../../assets/feather/calculate-dark.svg";
import Modal from "react-modal";
import iconExit from "../../assets/feather/x-circle.svg";
import {auth} from "../../store/auth.store";

const tabs = [
    {value: "", label: "BEKLEYEN", content: <TicketList status={null}/>},
    {value: "kazanan-biletlerim", label: "KAZANAN", content: <TicketList status={2}/>},
    {value: "kaybeden-biletlerim", label: "KAYBEDEN", content: <TicketList status={3}/>},
    {value: "kayitli-biletlerim", label: "KAYITLI", content: <TicketList status={6}/>},
    {value: "hazir-kuponlar", label: "HAZIR KUPONLAR", content: <TicketList status={7}/>},
];

const statusMap: any = {
    0: {label: "Beklemede", class: "text-bg-secondary"},
    1: {label: "Oynandı", class: "text-bg-secondary"},
    2: {label: "Kazandı", class: "text-bg-success"},
    3: {label: "Kaybetti", class: "text-bg-danger"},
    4: {label: "İptal", class: "text-bg-secondary"},
    5: {label: "Oynanamadı / Hatalı", class: "text-bg-danger"},
    6: {label: "Kayıtlı", class: "text-bg-secondary"},
    7: {label: "Hazır Kupon", class: "text-bg-secondary"},
    8: {label: "İptal Beklemede", class: "text-bg-warning"},
};

export function MemberTickets() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentTab = tabs.find((tab) => tab.value === location.pathname.split("/")[2]) ?? tabs[0];

    const handleTabChange = (e: any) => {
        navigate(e.target.id)
    }

    return (
        <>
            <h1>Biletlerim</h1>
            <div className="page-widget">
                <svg style={{display: "none"}}>
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                    </defs>
                </svg>

                {/* Tab Header */}
                <div className={"tab-scroll"}>
                    <ul className="nav nav-tabs">
                        {tabs.map(({value, label}: { value: string; label: string }, index) => {
                            if(!auth.member.is_editor && value === "hazir-kuponlar") return null;
                            return (
                                <li
                                    key={`tabs-index-${index}`}
                                    className={`nav-item ${currentTab.value === value ? "active" : ""}`}
                                    onClick={handleTabChange}
                                >
                                    <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                    <a className="nav-link" id={`${value}`}>
                                        {label.toUpperCase()}
                                    </a>
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className="p-1">{currentTab.content}</div>
            </div>
        </>
    );
}

function TicketList(prop: any) {
    const status = prop.status;
    const [listTickets, setListTickets] = useState<any>(null);
    const [listDetails, setListDetails] = useState<any>([]);
    const [profitModal, setProfitModal] = useState<any>(null);
    const [pageShown, setPageShown] = useState(1);
    const [pageMaxSize, setPageMaxSize] = useState(1);
    const [selectedHorses, setSelectedHorses] = useState<any>({});

    const navigate = useNavigate();
    const bulletinCardId = useBulletinCardId();
    const hippodromesMap = useHippodromesMap();

    const loadData = (page: any) => {
        setPageShown(page);
        let api = new ApiService();
        api
            .start(
                "post",
                env.accounting_api + "/games/api/tjk/coupons",
                {
                    status: status,
                    page: page,
                },
                true
            )
            .then((res: any) => {
                if (res.status) {
                    setPageMaxSize(res.data.total);
                    if (!listTickets || page === 1) {
                        setListTickets(res.data.data);
                    } else {
                        setListTickets([...listTickets.concat(res.data.data)]);
                    }
                } else {
                    setListTickets(null);
                }
            })
            .catch(() => {
                setListTickets(null);
            });
    };

    useEffect(() => {
        setListTickets(null);
        loadData(1);

        return () => {
        }
    }, [prop, prop.status]);

    if (listTickets === null) {
        return (
            <>
                <p className="text-center p-5">Sayfa yükleniyor lütfen bekleyiniz...</p>
            </>
        );
    } else if (listTickets && listTickets.length === 0) {
        return (
            <>
                <p className="text-center p-5">Listelenecek hiç biletiniz yok.</p>
            </>
        );
    }

    const cancelTjkCoupon = (c: any) => {
        modalServiceSubject.next({
            title: "Emin misiniz?",
            content: `${c.approve_code || c.id} numaralı kuponunuzu iptal etmek istediğinizden emin misiniz?`,
            confirm: {
                sure: {
                    class: "btn-danger",
                    label: "İptal et",
                    autoClose: false,
                    action: () => {
                        modalServiceSubject.next({
                            case: "info",
                            title: "Biletiniz İptal Ediliyor",
                            content: '<div class="text-center"><div class="loader" style="display:block"></div><p>İptal talebiniz United Racing sistemine iletildi. Yanıt gelene kadar lütfen bekleyiniz.</p></div>',
                            confirm: null,
                            backdropCloseDisabled: true,
                        });
                        let api = new ApiService();
                        api
                            .start(
                                "post",
                                env.accounting_api + "/games/api/tjk/cancel",
                                {
                                    coupon_id: c.id,
                                },
                                true
                            )
                            .then((res: any) => {
                                if (res.status) {
                                    loadData(1);
                                    modalServiceSubject.next({
                                        case: "success",
                                        title: "Biletiniz İptal Edildi",
                                        content: `<p class="text-center"><b>${c.approve_code || c.id}</b> numaralı biletiniz iptal edildi. Bilet tutarı hesabınıza iade edilecektir. Biletin güncel durumunu Biletlerim listesinden takip edebilirsiniz.</p>`,
                                        confirm: {
                                            cancel: {
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                } else {
                                    if (res.data?.error?.error_message === "TIMEOUT") {
                                        setListTickets((prevState: any) =>
                                            prevState.map((ticket: any) =>
                                                ticket.id === c.id ? { ...ticket, status: 8 } : ticket
                                            )
                                        );
                                    }
                                    modalServiceSubject.next({
                                        title: res.message ?? 'İşlem Başarısız',
                                        content: res.data?.error?.error_description ?? 'Beklenmeyen bir hata gerçekleşti, lütfen kuponlarım sayfasından takip ediniz.',
                                        timeout: 10000,
                                        confirm: {
                                            cancel: {
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                }
                            })
                            .catch((err: any) => {

                                modalServiceSubject.next({
                                    title: "Hata",
                                    content: err,
                                    timeout: 3000,
                                    confirm: {
                                        cancel: {
                                            label: "Tamam",
                                        },
                                    },
                                });
                            });
                    },
                },
                cancel: {
                    label: "Vazgeç",
                },
            },
        });
    };

    const deleteTjkCoupon = (c: any) => {
        modalServiceSubject.next({
            title: "Emin misiniz?",
            content: `${c.approve_code || c.id} numaralı kuponunuzu silmek istediğinizden emin misiniz?`,
            confirm: {
                sure: {
                    class: "btn-danger",
                    label: "Sil",
                    autoClose: false,
                    action: () => {
                        modalServiceSubject.next({
                            case: "info",
                            title: "Kuponunuz Siliniyor",
                            content: '<div class="text-center"><div class="loader" style="display:block"></div><p>Kuponunuz kayıtlarınızdan siliniyor. Lütfen bekleyiniz.</p></div>',
                            confirm: null,
                            backdropCloseDisabled: true,
                        });
                        let api = new ApiService();
                        api
                            .start(
                                "post",
                                env.accounting_api + "/games/api/tjk/delete-saved",
                                {
                                    coupon_id: c.id,
                                },
                                true
                            )
                            .then((res: any) => {
                                if (res.status) {
                                    loadData(1);
                                    modalServiceSubject.next({
                                        case: "success",
                                        title: "Kuponunuz Silindi",
                                        content: `<p class="text-center"><b>${c.approve_code || c.id}</b> numaralı kuponunuz kayıtlarınızdan silindi.</p>`,
                                        confirm: {
                                            cancel: {
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                } else {
                                    let modalTitle = "İşlem başarısız!";
                                    if (res && res.data && res.data.error && res.data.error.error_description) {
                                        modalTitle = res.message;
                                        res.message += `<p>${res.data.error.error_description}</p>`;
                                    }

                                    modalServiceSubject.next({
                                        title: modalTitle,
                                        content: res.message,
                                        timeout: 10000,
                                        confirm: {
                                            cancel: {
                                                label: "Tamam",
                                            },
                                        },
                                    });
                                }
                            })
                            .catch((err: any) => {

                                modalServiceSubject.next({
                                    title: "Hata",
                                    content: err,
                                    timeout: 3000,
                                    confirm: {
                                        cancel: {
                                            label: "Tamam",
                                        },
                                    },
                                });
                            });
                    },
                },
                cancel: {
                    label: "Vazgeç",
                },
            },
        });
    };

    const playTicket = (ticket: any) => {
        const {isFob, isCombine, isH2H} = getTicketClassification(ticket.bet_type);
        const hippodrome = bulletinCardId[Number(ticket.card_id)];
        if (!isCombine && !isH2H) {
            if (!hippodrome) {
                showExpiredTicketModal();
                return;
            }
            const betType = hippodrome.wager_details.find((w: any) => Number(w.type) === Number(ticket.bet_type));
            if (!betType || !betType.runs.includes(ticket.race_id)) {
                showExpiredTicketModal();
                return;
            }
        }

        if (isFob) {
            try {
                replayFobTicketToBetslip(ticket, navigate);
            } catch (error: any) {
                showMutualReplayError(error?.message ?? "Kupon yüklenemedi.");
            }
            return;
        }

        try {
            restoreMutualCoupon(hippodrome, ticket);
        } catch (error: any) {
            showMutualReplayError(error?.message ?? "Kupon yüklenemedi.");
            return;
        }

        navigate(`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`);
    };

    const showDetail = (ticket: any) => {
        setListDetails((prev: any[]) =>
            prev.includes(ticket.id) ? prev.filter((id: any) => id !== ticket.id) : [...prev, ticket.id]
        );
    };

    const calculateProfit = () => {
        if (profitModal != null) {
            if (Object.keys(selectedHorses).length === 6) {
                const card = bulletinCardId[Number(profitModal.card_id)];
                const agfRatioField = ticketAgfRatioField(profitModal);
                const calculatedAgfRatio = Object.values(selectedHorses).reduce(
                    (acc: number, horse: any) => acc * (100 / Number(horse[agfRatioField])),
                    1
                );
                const isSystemCoupon = (Array.isArray(profitModal.legs) ? profitModal.legs : [])
                    .some((leg: any) => (Array.isArray(leg) ? leg : [leg]).some((h: any) => Number(h) === 32));
                const paidUnitPrice = Number(profitModal.amount) / (Number(profitModal.multiply) * Number(profitModal.bet_count));
                const unitPrice = !isSystemCoupon && Number.isFinite(paidUnitPrice) && paidUnitPrice > 0
                    ? paidUnitPrice
                    : Number(card?.wager_details?.find((w: any) => Number(w.type) === Number(profitModal.bet_type))?.price);
                if (!Number.isFinite(calculatedAgfRatio) || !Number.isFinite(unitPrice)) {
                    return "Bu kupon için tahmin hesaplanamıyor";
                }
                return (
                    CurrencyFormat(calculatedAgfRatio * unitPrice * 0.4, 2) +
                    " ₺ - " +
                    CurrencyFormat(calculatedAgfRatio * unitPrice * 0.6, 2) +
                    " ₺"
                );
            } else {
                return "Bütün ayaklar için bir at seçiniz";
            }
        }
        return "";
    };

    return (
        <div className={"table-responsive"}>
            <table className="table table-borderless betting-table ticket-table">
                <thead>
                <tr>
                    {!isMobile && <th>Bilet No</th>}
                    <th>Tarih</th>
                    {!isMobile && <th>Hipodrom</th>}
                    <th>Bahis Türü</th>
                    {!isMobile && <th>Koşu</th>}
                    {status === 2 && <th>Kazanç</th>}
                    {!isMobile && <th>Tutar</th>}
                    {!isMobile && <th>#</th>}
                    {isMobile && <th className={"text-end"}>Tutar</th>}
                </tr>
                </thead>
                <tbody>
                {listTickets &&
                    listTickets.map((ticket: any, keyTicket: number) => {
                        const {isCombine, isLongterm, isFob} = getTicketClassification(ticket.bet_type);

                        return (
                            <React.Fragment key={`tickets-${keyTicket}`}>
                                <tr>
                                    <th className="seperator"></th>
                                </tr>
                                <tr
                                    className={`${listDetails.includes(ticket.id) ? "active" : ""} cursor-pointer ticket`}
                                    onClick={(e: any) => {
                                        if (e.target.nodeName === "TD" || e.target.nodeName === "IMG") {
                                            showDetail(ticket);
                                        }
                                    }}
                                >
                                    {!isMobile && (
                                        <td>
                                            {ticket.status !== 6 && ticket.approve_code
                                                ? ticket.approve_code
                                                : ticket.status === 6
                                                    ? ticket.id
                                                    : "Oynanıyor"}
                                        </td>
                                    )}

                                    <td
                                        onClick={() => {
                                            showDetail(ticket);
                                        }}
                                    >
                                        {isMobile && (
                                            <span>
                                                {isLongterm ? (Object.values(ticket.legs?.[0] || {})[0] as any)?.hippodrome : (ticket.card ? hippodromesMap[ticket.card.split("-")[1].replace('diyarbakir', 'dbakir')]?.YER : "")}
                                                <br/>
                                            </span>
                                        )}
                                        <span
                                            className={"text-center"}
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    ticket.status !== 6 && ticket.approve_code
                                                        ? dateTimeFormat(ticket.approve_date).replaceAll(" ", "<br/>")
                                                        : dateTimeFormat(ticket.create_date).replaceAll(" ", "<br/>"),
                                            }}
                                        ></span>
                                    </td>

                                    {!isMobile &&
                                        <td>{isLongterm ? (Object.values(ticket.legs?.[0] || {})[0] as any)?.hippodrome : (ticket.card && !isCombine ? hippodromesMap[ticket.card.split("-")[1].replace('diyarbakir', 'dbakir')]?.YER : "")}</td>}

                                    <td className={"nowrap-ellipsis tooltip"}>
                                        {BettingTypesMap[Number(ticket.bet_type)]?.shortName != null
                                            ? BettingTypesMap[Number(ticket.bet_type)]?.shortName
                                            : BettingTypesMap[Number(ticket.bet_type)]?.name}{" "}
                                        {[52, 55, 62].includes(Number(ticket.bet_type)) && ticket.legs?.length === 1 ? "(V)" : ""}
                                        {isMobile && (
                                            <span>
                                                    <br/>({isLongterm ? '-' : ticket.race_id})
                                                </span>
                                        )}
                                        {!listDetails.includes(ticket.id) && (
                                            <span className={"tooltip-text"}>
                                                    {BettingTypesMap[Number(ticket.bet_type)]?.name}{" "}
                                                {[52, 55, 62].includes(Number(ticket.bet_type)) && ticket.legs?.length === 1
                                                    ? "(Virgüllü)"
                                                    : ""}
                                                </span>
                                        )}
                                    </td>
                                    {!isMobile && <td>{isCombine || isLongterm ? '-' : ticket.race_id}</td>}
                                    {ticket.status === 2 && (
                                        <td className="text-success fw-bold">
                                            {ticket.refund !== ticket.winning && ticket.winning + "₺"}
                                            {ticket.refund && Number(ticket.refund) > 0
                                                ? (
                                                    <span className="d-block text-dark fw-normal">( {ticket.refund}₺ iade)</span>
                                                )
                                                : (
                                                    <></>
                                                )}
                                        </td>
                                    )}
                                    {!isMobile && <td>{CurrencyFormat(Number(ticket.amount || 0))} ₺</td>}
                                    <td className={`${isMobile ? "text-end" : ""}`}>
                                        <div className={"d-flex justify-content-between align-items-center"}>
                                            {isMobile && (
                                                <>
                                                    {" "}
                                                    {CurrencyFormat(Number(ticket.amount || 0))} ₺ <br/>
                                                </>
                                            )}
                                            <div
                                                className={"d-flex flex-column align-items-center justify-content-center"}>
                                                {bulletinCardId[Number(ticket.card_id)]?.runsMap[ticket.race_id]?.status === 0 &&
                                                ticket.status === 1 &&
                                                !isFob ? (
                                                    <span
                                                        className="badge text-bg-danger cursor-pointer"
                                                        onClick={() => {
                                                            cancelTjkCoupon(ticket);
                                                        }}
                                                    >
                                                            İptal Et
                                                        </span>
                                                ) : (
                                                    <span className={"badge " + (statusMap[ticket.status]?.class || "")}>
                                                            {statusMap[ticket.status]?.label}
                                                        </span>
                                                )}
                                                <div>
                                                    {listDetails.includes(ticket.id) && <span
                                                        className="badge text-bg-info cursor-pointer mt-2"
                                                        onClick={() => {
                                                            shareOnSocial("ticket-detail-container-" + ticket.id);
                                                        }}>
                                                            Paylaş
                                                        </span>}
                                                </div>
                                            </div>

                                            {listDetails.includes(ticket.id)
                                                ? <img src={chevronUp}/>
                                                : <img src={chevronDown}/>}
                                        </div>
                                    </td>
                                </tr>


                                {[0, 8].includes(Number(ticket.status)) && !listDetails.includes(ticket.id) && <tr>
                                    <th colSpan={isMobile ? 4 : ticket.status === 2 ? 8 : 7} className={"p-0"}>
                                        <p className="my-1 alert alert-warning p-2 fs-7 fw-bold">
                                            {Number(ticket.status) === 8
                                                ? "İptal Beklemede statüsünde olan biletleriniz iptal edildi anlamına gelmez. İptal talebiniz iletildi, sonuçlanana kadar biletiniz geçerlidir. İptal onaylandığında bilet tutarı hesabınıza iade edilir."
                                                : "Beklemede statüsünde olan kuponlarınız oynandı anlamına gelmez. Lütfen Barkod numarası (Bilet No) gelene kadar bekleyiniz."}
                                        </p>
                                    </th>
                                </tr>}


                                {listDetails.includes(ticket.id) ? (
                                    <>
                                        <tr className="ticket-detail new">
                                            <th colSpan={isMobile ? 4 : ticket.status === 2 ? 8 : 7} className="pt-0">
                                                {isMobile && (
                                                    <h3>
                                                        Bilet Detayı
                                                        <span className="float-end">
                                                                NO:
                                                            {ticket.status !== 6 && ticket.approve_code
                                                                ? ticket.approve_code
                                                                : ticket.status === 6
                                                                    ? ticket.id
                                                                    : "Oynanıyor"}
                                                            </span>
                                                    </h3>
                                                )}
                                                <div id={"ticket-detail-container-" + ticket.id}
                                                     className={"ticket-detail-container"}>
                                                    <div
                                                        className={"justify-content-center align-items-center w-100"}
                                                        style={{display: 'none'}}>
                                                        <img
                                                            alt={"4nala"}
                                                            className={"mt-2"}
                                                            src="/assets/logo_at_yarisi_hipodrom_4nala_atyarisi.png"
                                                        />
                                                    </div>
                                                    <div id={"ticket-detail-inner-content-" + ticket.id}
                                                         className={"ticket-detail-inner-content"}>
                                                        <TicketDetail ticket={ticket} onCalcProfit={setProfitModal}/>
                                                    </div>
                                                </div>

                                                <TicketActions
                                                    ticket={ticket}
                                                    isFob={isFob}
                                                    isCombine={isCombine}
                                                    isLongterm={isLongterm}
                                                    onPlay={() => playTicket(ticket)}
                                                    onCancel={() => cancelTjkCoupon(ticket)}
                                                    onDelete={() => deleteTjkCoupon(ticket)}
                                                />
                                            </th>
                                        </tr>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
                <tfoot>
                <tr>
                    <td colSpan={6} className="ps-0 pt-4">
                        {listTickets && pageMaxSize > listTickets.length && (
                            <button
                                className="btn btn-sm btn-info"
                                onClick={() => {
                                    loadData(pageShown + 1);
                                }}
                            >
                                Devamını Yükle
                            </button>
                        )}
                    </td>
                </tr>
                </tfoot>
            </table>

            <Modal
                isOpen={profitModal !== null}
                onRequestClose={() => {
                    setProfitModal(null);
                }}
                onAfterClose={() => {
                    setSelectedHorses({});
                }}
                ariaHideApp={false}
                style={{
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        width: "1140px",
                        maxHeight: "calc(100% - 40px)",
                        marginRight: "-50%",
                        maxWidth: " calc( 100% - 40px )",
                        padding: "10px",
                        transform: "translate(-50%, -50%)",
                        background: "var(--bs-white)",
                        borderRadius: "var(--bs-border-radius-xl)",
                        border: 0,
                    },
                    overlay: {
                        zIndex: 2,
                        backgroundColor: "rgba(0, 0, 0, 0.25)",
                        backdropFilter: "blur(10px)",
                    },
                }}
                contentLabel=""
            >
                <div className="card mt-0">
                    <div className="title modal-sticky-title">
                        <div className={"float-end"}>
                            <img
                                alt={"iconExit"}
                                src={iconExit}
                                width={24}
                                className={"float-end cursor-pointer"}
                                onClick={() => setProfitModal(null)}
                            />
                        </div>
                        <h3>İkramiye Hesaplama</h3>
                    </div>
                    {profitModal != null && (
                        <ProfitCalculatorModal ticket={profitModal} selectedHorses={selectedHorses} setSelectedHorses={setSelectedHorses}/>
                    )}

                    <div className={"footer sticky-bottom bg-white px-2 py-3"} style={{bottom: "-15px"}}>
                        <p className={`${isMobile ? "fs-6" : "fs-5"}`}>
                            Tahmini İkramiye: <b>{calculateProfit()}</b>
                        </p>
                        <p className="my-1 alert alert-warning">
                            <b>"Bu 6'lı Ganyan Ne Verir?"</b> özelliği ile hesaplanan ikramiye tutarı, tahmini olarak
                            hesaplanmaktadır. Resmi ikramiye tutarı, paylaşılan resmi sonuçların ilanından sonra
                            belli olur.
                        </p>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

function TicketDetail({ticket, onCalcProfit}: { ticket: any; onCalcProfit: (ticket: any) => void }) {
    const hippodromesMap = useHippodromesMap();
    const classification = getTicketClassification(ticket.bet_type);
    const {isCombine, isLongterm, isFob, isPairColumn} = classification;
    const hasRows = Array.isArray(ticket.rows) && ticket.rows.length > 0;

    const legs = useMemo(
        () => (isLongterm ? [] : normalizeTicketLegs(ticket)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ticket.id, hasRows, isLongterm]
    );
    const [legsState, setLegsState] = useState<{ resolved: Map<string, { run: any; error: boolean }>; loading: boolean }>({
        resolved: new Map(),
        loading: true,
    });
    useEffect(() => {
        let cancelled = false;
        setLegsState({resolved: new Map(), loading: true});

        (async () => {
            const resolved = await resolveTicketLegRuns(legs, ticket.id);
            if (!cancelled) {
                setLegsState({resolved, loading: false});
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket.id]);
    const {resolved, loading} = legsState;

    if (isLongterm) {
        const legInfo: any = Object.values(ticket.legs?.[0] || {})[0] || {};
        return (
            <>
                <TicketSummaryTable
                    ticket={ticket}
                    classification={classification}
                    hipodromName={legInfo.hippodrome}
                    raceIdText="-"
                    resultsText=""
                    showFobFinance={true}
                    onCalcProfit={() => onCalcProfit(ticket)}
                />
                <div className="coupon-legs row">
                    <div className="col-12">
                        <div className="run-no d-flex justify-content-between px-3">{legInfo.hippodrome}</div>
                        <div className="horse-no d-flex justify-content-between" style={mobileView ? {background: "var(--color-bg-white)"} : {}}>
                            <div className="text-left" style={{paddingLeft: 5}}>{legInfo.description}</div>
                            <div style={{paddingRight: 5}}>{ticketOddText(ticket)}</div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const segmentFor = (leg: NormalizedLeg): string => {
        const r = resolved.get(leg.key);
        const run = r && !r.error ? r.run : null;
        return BettingTypesMap[leg.betType]?.isFob ? fobResultsSegment(leg.betType, run) : classicResultsSegment(leg.betType, run);
    };
    let resultsText = "-";
    if (legs.length > 0) {
        resultsText = (!isCombine && isPairColumn)
            ? (segmentFor(legs[0]) || "-")
            : (legs.map((leg) => segmentFor(leg)).join(runSeparator) || "-");
    }

    const hipodromName = isCombine ? "" : (
        hasRows
            ? (ticket.rows[0] ? (ticket.rows[0].hippodrome_name || hippodromesMap[rowHippodromeKeyword(ticket.rows[0].card)]?.HIPODROM || rowHippodromeKeyword(ticket.rows[0].card)) : "")
            : (ticket.card ? hippodromesMap[rowHippodromeKeyword(ticket.card)]?.HIPODROM : "")
    );
    const isSingleRace = hasRows
        && new Set(ticket.rows.map((r: any) => `${r.card}_${r.race_id}`)).size === 1;
    const raceIdText = hasRows ? (isSingleRace ? ticket.rows[0].race_id : "-") : ticket.race_id;

    const boxColClass = isMobile ? "col-12" : (legs.length > 1 ? "col-6 mt-2" : "col-12");

    return (
        <>
            <TicketSummaryTable
                ticket={ticket}
                classification={classification}
                hipodromName={hipodromName}
                raceIdText={raceIdText}
                resultsText={resultsText}
                showFobFinance={isFob}
                onCalcProfit={() => onCalcProfit(ticket)}
            />
            {loading ? (
                <p className="text-center p-2">Koşu bilgileri yükleniyor...</p>
            ) : (
                <div className="coupon-legs row">
                    {legs.map((leg) => {
                        const r = resolved.get(leg.key);
                        if (!r || r.error) {
                            return <LegErrorBox key={leg.key} legKey={leg.key} colClass={boxColClass}/>;
                        }

                        return (
                            <LegCard
                                key={leg.key}
                                leg={leg}
                                run={r.run}
                                winners={computeLegWinner(leg.betType, r.run, leg.pairSelections ?? leg.selections, leg.positionInRace)}
                                colClass={boxColClass}
                                showOdds={hasRows}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
}

function TicketActions({ticket, isFob, isCombine, isLongterm, onPlay, onCancel, onDelete}: {
    ticket: any; isFob: boolean; isCombine: boolean; isLongterm: boolean;
    onPlay: () => void; onCancel: () => void; onDelete: () => void;
}) {
    const bulletinCardId = useBulletinCardId();
    const availableHippodromes = useAvailableHippodromes();
    const legs = useMemo(
        () => (isLongterm ? [] : normalizeTicketLegs(ticket)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ticket.id, isLongterm]
    );
    const primaryLeg = legs[0] ?? null;
    const [primaryLegState, setPrimaryLegState] = useState<{ resolved: Map<string, { run: any; error: boolean }>; loading: boolean }>({
        resolved: new Map(),
        loading: true,
    });
    useEffect(() => {
        if (!primaryLeg) {
            return;
        }
        let cancelled = false;
        setPrimaryLegState({resolved: new Map(), loading: true});

        (async () => {
            const resolved = await resolveTicketLegRuns([primaryLeg], ticket.id);
            if (!cancelled) {
                setPrimaryLegState({resolved, loading: false});
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket.id]);

    let primaryFinished: boolean | null = null;
    if (primaryLeg && !primaryLegState.loading) {
        const r = primaryLegState.resolved.get(primaryLeg.key);
        if (r && !r.error && r.run) {
            primaryFinished = r.run.is_finished === true;
        }
    }

    const liveRun = bulletinCardId[Number(ticket.card_id)]?.runsMap[ticket.race_id];
    const isReplayable = isCombine
        ? legs.length > 0 && legs.every((leg) => availableHippodromes.find(
            (h: any) => `${h._date}-${h.keyword.toLowerCase()}` === leg.card)?.runsMap[Number(leg.raceNo)]?.status === 0)
        : liveRun?.status === 0;

    return (
        <div className={"row"}>
            {liveRun?.status === 0 && ticket.status === 1 && !isFob && (
                <div className="foot danger two-btn cursor-pointer" onClick={onCancel}>
                    BİLETİ İPTAL ET
                </div>
            )}

            {isReplayable && ticket.status === 1 && (
                <div
                    className={"foot float-start warning cursor-pointer " + (!isFob ? "two-btn" : "")}
                    onClick={onPlay}
                >
                    TEKRAR OYNA
                </div>
            )}

            {ticket.status === 6 && (
                <div
                    className={"foot  cursor-pointer " + (primaryFinished === false ? "two-btn danger  float-end " : "")}
                    onClick={onDelete}
                >
                    KAYDI SİL
                </div>
            )}
            {ticket.status === 7 && (
                <div className={"foot  cursor-pointer danger"} onClick={onDelete}>
                    KAYDI SİL
                </div>
            )}

            {primaryFinished === false && ticket.status === 6 && (
                <div className="foot float-start warning cursor-pointer two-btn" onClick={onPlay}>
                    OYNA
                </div>
            )}

            {!isReplayable && ticket.status !== 6 && ticket.status !== 7 && <div className="foot cursor-pointer"></div>}
        </div>
    );
}

function TicketSummaryTable({ticket, classification, hipodromName, raceIdText, resultsText, showFobFinance, onCalcProfit}: {
    ticket: any;
    classification: any;
    hipodromName: string;
    raceIdText: any;
    resultsText: string;
    showFobFinance: boolean;
    onCalcProfit: () => void;
}) {
    const bulletinCardId = useBulletinCardId();
    const {isCombine} = classification;
    const betTypeLabel = BettingTypesMap[Number(ticket.bet_type)]?.shortName != null
        ? BettingTypesMap[Number(ticket.bet_type)]?.shortName
        : BettingTypesMap[Number(ticket.bet_type)]?.name;
    // Kupon ekranıyla aynı kural: KO bacağı varsa gösterilen rakamın yanına "+ KO"
    // (o rakam KO bacağını çarpıma katmadığı için EKSİKTİR). Oranın kendisi sunucuda
    // yoksa satırlardan türetiliyor (bkz. ticketOdds) - kayıtlı kuponda tam olarak bu olur.
    const odds = ticketOdds(ticket);
    const hasKnownOdds = odds.total !== null;
    const koSuffix = odds.hasClosing ? " + KO" : "";
    // Sunucunun tutarı yalnız toplam oranı DA hesapladığında güvenilir: kayıtlı kuponda ikisi
    // de hesaplanmıyor ve `fob_profit` kupon tutarına eşit geliyor. O durumda tutar
    // satırlardan hesaplanır: sistemsizde oran × misli, sistemlide kombinasyon toplamı.
    const ticketMultiply = Number(ticket.multiply) || 0;
    const isSystemTicket = Number(ticket.bet_type) === BettingTypeIds.combineSystem;
    const systemMax = isSystemTicket ? ticketSystemMaxWin(ticket) : null;
    const maxWinCell = (Number(ticket.fob_odd_ratio) > 1 && Number(ticket.fob_profit) > 0)
        ? `${ticket.fob_profit}₺${koSuffix}`
        : (hasKnownOdds && ticketMultiply > 0 && !isSystemTicket
            ? `${CurrencyFormat(odds.total! * ticketMultiply)}₺${koSuffix}`
            : (systemMax !== null
                ? `${CurrencyFormat(systemMax)}₺${koSuffix}`
                : (odds.hasRows && odds.hasClosing && !hasKnownOdds ? "KO" : "-")));
    const hasPayout = Number(ticket.winning) > 0 || Number(ticket.refund) > 0;
    const isRefundOnly = Number(ticket.winning) <= Number(ticket.refund);
    const financeLabel = hasPayout ? (isRefundOnly ? "İade" : "Kazanç") : "Maks. Kazanç";
    const financeCell = hasPayout ? (
        <>
            {!isRefundOnly && ticket.winning + "₺"}
            {Number(ticket.refund) > 0 ? (
                <span className="d-block text-dark fw-normal">( {ticket.refund}₺ iade)</span>
            ) : null}
        </>
    ) : (showFobFinance ? maxWinCell : "-");
    const systemOdds: number[] = Array.isArray(ticket.rows)
        ? ticket.rows.map((row: any) => Number(row.odd_ratio) || 1).sort((a: number, b: number) => a - b)
        : [];
    const systemSizes = String(ticket.system ?? "").split(",")
        .map(Number)
        .filter((k) => Number.isFinite(k) && k >= 1 && k <= systemOdds.length);
    const minWinCell = !hasPayout && hasKnownOdds && maxWinCell !== "-"
        && Number(ticket.bet_type) === BettingTypeIds.combineSystem && systemSizes.length > 0
        ? `${(Math.min(...systemSizes.map((k) => systemOdds.slice(0, k).reduce((acc, odd) => acc * odd, 1))) * Number(ticket.multiply || 0)).toFixed(2)}₺`
        : null;
    const financeCellWithInfo = !hasPayout && showFobFinance && hasKnownOdds && maxWinCell !== "-" && ![2, 3, 4, 5].includes(Number(ticket.status))
        ? (
            <div className="d-flex justify-content-between align-items-center">
                <div>{financeCell}</div>
                <img src={iconInfo} alt="i" onClick={showMaxWinInfoModal} className="ms-2 cursor-pointer" width={21} height={21}/>
            </div>
        )
        : financeCell;
    const showCalcButton = Number(ticket.bet_type) === 18 &&
        bulletinCardId[Number(ticket.card_id)]?.runsMap[ticket.race_id] != null;

    return (
        <table className="table table-striped coupon-detail">
            <tbody>
            {!isCombine && (
                <tr>
                    <td className="text-left" style={{width: 100}}>Hipodrom</td>
                    <td className="text-left fw-normal">{hipodromName}</td>
                    <td className="text-left" style={{width: 100}}>Bahis Türü</td>
                    <td className="text-left fw-normal">{betTypeLabel}</td>
                    {!isMobile && <td className="text-left" style={{width: 100}}>Koşu</td>}
                    {!isMobile && <td className="text-left fw-normal">{raceIdText}</td>}
                </tr>
            )}
            {isMobile && (
                <tr>
                    <td className="text-left" style={{width: 100}}>Koşu</td>
                    <td className="text-left fw-normal">{raceIdText}</td>
                    <td className="text-left">Tutar</td>
                    <td className="text-left fw-normal">{CurrencyFormat(Number(ticket.amount || 0))}₺</td>
                </tr>
            )}
            <tr>
                {showFobFinance ? <td className="text-left">Toplam Oran</td> : <td className="text-left">Bahis Sayısı</td>}
                {showFobFinance
                    ? <td className="text-left fw-normal">{ticketOddText(ticket)}</td>
                    : <td className="text-left fw-normal">{ticket.bet_count}</td>}
                <td className="text-left">Misli</td>
                <td className="text-left fw-normal">{ticket.multiply}</td>
                {!isMobile && <td className="text-left">Tutar</td>}
                {!isMobile && <td className="text-left fw-normal">{CurrencyFormat(Number(ticket.amount || 0))}₺</td>}
            </tr>
            <tr>
                {isCombine && <td className="text-left" style={{width: 100}}>Bahis Türü</td>}
                {isCombine && <td className="text-left fw-normal">{betTypeLabel}</td>}
                {!isCombine && <td className="text-left">Sonuçlar</td>}
                {!isCombine && (
                    <td className="text-left fw-normal">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>{resultsText}</div>
                            <div className="d-flex align-items-center">
                                {!isMobile && showCalcButton && (
                                    <div>
                                        <button
                                            onClick={onCalcProfit}
                                            style={{width: "100%"}}
                                            className="btn btn-sm btn-outline-dark w-100 d-flex justify-content-center align-items-center fw-medium"
                                        >
                                            <img src={calculate} width={18} height={"auto"} className="me-1"/>
                                            Bu 6'lı Ne Verir?
                                        </button>
                                    </div>
                                )}
                                <img src={iconInfo} alt="i" onClick={showWinnerColorInfoModal} className="ms-2" width={21} height={21}/>
                            </div>
                        </div>
                    </td>
                )}
                <td className="text-left">Durum</td>
                <td className="text-left fw-normal">
                    <span className={"badge " + (statusMap[ticket.status]?.class || "")}>{statusMap[ticket.status]?.label}</span>
                </td>
                {!isMobile && <td className="text-left">{financeLabel}</td>}
                {!isMobile && <td className="text-left fw-normal">{financeCellWithInfo}</td>}
            </tr>
            {isCombine && (
                <tr>
                    <td className="text-left">Sonuçlar</td>
                    <td className="text-left fw-normal">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>{resultsText}</div>
                            <div className="d-flex align-items-center">
                                <img src={iconInfo} alt="i" onClick={showWinnerColorInfoModal} className="ms-2" width={21} height={21}/>
                            </div>
                        </div>
                    </td>
                    {ticket.system && Number(ticket.bet_type) === BettingTypeIds.combineSystem ? (
                        <>
                            <td className="text-left">Sistem</td>
                            <td className="text-left fw-normal">{ticket.system.replaceAll(",", "-")}</td>
                        </>
                    ) : (
                        <>
                            <td></td>
                            <td></td>
                        </>
                    )}
                    {!isMobile && minWinCell ? <td className="text-left">Min. Kazanç</td> : <td></td>}
                    {!isMobile && minWinCell ? <td className="text-left fw-normal">{minWinCell}</td> : <td></td>}
                </tr>
            )}
            {[0, 8].includes(Number(ticket.status)) && (
                <tr>
                    <td colSpan={isMobile ? 4 : 6}>
                        <p className="my-1 alert alert-warning p-2 fs-7 fw-bold">
                            {Number(ticket.status) === 8
                                ? "İptal Beklemede statüsünde olan biletleriniz iptal edildi anlamına gelmez. İptal talebiniz iletildi, sonuçlanana kadar biletiniz geçerlidir. İptal onaylandığında bilet tutarı hesabınıza iade edilir."
                                : "Beklemede statüsünde olan kuponlarınız oynandı anlamına gelmez. Lütfen Barkod numarası (Bilet No) gelene kadar bekleyiniz."}
                        </p>
                    </td>
                </tr>
            )}
            {isMobile && showCalcButton && (
                <tr>
                    <td className="pt-0" style={{"--bs-table-bg-type": "#FFFFFF"} as React.CSSProperties} colSpan={2}>
                        <div>
                            <label
                                onClick={onCalcProfit}
                                style={{width: "100%"}}
                                className="w-100 d-flex justify-content-start align-items-center fw-medium"
                            >
                                <img src={calculate} width={18} height={"auto"} className="me-1"/>
                                Bu 6'lı Ne Verir?
                            </label>
                        </div>
                    </td>
                    <td style={{"--bs-table-bg-type": "#FFFFFF"} as React.CSSProperties} colSpan={2}></td>
                </tr>
            )}
            {isMobile && (
                <tr>
                    <td className="text-left" colSpan={2}>{financeLabel}</td>
                    <td className="text-left fw-normal" colSpan={2}>{financeCellWithInfo}</td>
                </tr>
            )}
            {isMobile && minWinCell && (
                <tr>
                    <td className="text-left" colSpan={2}>Min. Kazanç</td>
                    <td className="text-left fw-normal" colSpan={2}>{minWinCell}</td>
                </tr>
            )}
            </tbody>
        </table>
    );
}

function ticketAgfRatioField(ticket: any): "agf_ratio1" | "agf_ratio2" {
    const card = getBulletinCardId()[Number(ticket.card_id)];
    return card?.secondSixStart != null && Number(ticket.race_id) === Number(card.secondSixStart)
        ? "agf_ratio2"
        : "agf_ratio1";
}

function ProfitCalculatorModal({ticket, selectedHorses, setSelectedHorses}: {
    ticket: any; selectedHorses: any; setSelectedHorses: (updater: any) => void;
}) {
    const legs = useMemo(
        () => normalizeTicketLegs(ticket),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ticket.id]
    );
    const [legsState, setLegsState] = useState<{ resolved: Map<string, { run: any; error: boolean }>; loading: boolean }>({
        resolved: new Map(),
        loading: true,
    });
    useEffect(() => {
        let cancelled = false;
        setLegsState({resolved: new Map(), loading: true});

        (async () => {
            const resolved = await resolveTicketLegRuns(legs, ticket.id);
            if (!cancelled) {
                setLegsState({resolved, loading: false});
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket.id]);
    const {resolved, loading} = legsState;

    useEffect(() => {
        if (loading) {
            return;
        }
        const defaults: Record<string, any> = {};
        legs.forEach((leg, key) => {
            const r = resolved.get(leg.key);
            const run = r && !r.error ? r.run : null;
            const winners = run ? computeClassicLegWinnerSet(ticket.bet_type, run, 0) : null;
            const winningHorse = winners ? run.horses.find((h: any) => winners!.has(String(h.no))) : null;
            if (winningHorse) {
                defaults[key] = winningHorse;
            }
        });
        if (Object.keys(defaults).length > 0) {
            setSelectedHorses((prev: any) => ({...defaults, ...prev}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, resolved]);

    if (loading) {
        return <div className="body"><p className="text-center p-2">Koşu bilgileri yükleniyor...</p></div>;
    }

    return (
        <div className="body">
            <div className={`coupon-legs row`}>
                {legs.map((leg, key) => {
                    const r = resolved.get(leg.key);
                    const run = r && !r.error ? r.run : null;
                    return (
                        <div key={"tickets-" + key} className={`${isMobile ? "col-12 mt-1" : "col-4 mt-2"}`}>
                            <div className="run-no d-flex justify-content-between px-3">
                                {key + 1} . {BettingTypesMap[Number(ticket.bet_type)]?.columnLabel}
                            </div>
                            {leg.selections.map((item: string, horseKey: number) => {
                                const horse = (run?.horses || []).find((e: any) => Number(e.no) === Number(item));
                                if (!horse) {
                                    return <React.Fragment key={`order-detail-horse-${horseKey}`}/>;
                                }

                                return (
                                    <div
                                        key={`order-detail-horse-${horseKey}`}
                                        className="horse-no d-flex justify-content-between mt-1 align-items-center"
                                        style={mobileView ? {background: "var(--color-bg-white)"} : {}}
                                    >
                                        <div className={"text-left w-50"} style={{paddingLeft: 5}}>
                                            {horse.no} - {horse.name}
                                        </div>
                                        <div style={{paddingRight: 5}} className={"text-end fw-bold flex-fill"}>
                                            %{horse[ticketAgfRatioField(ticket)]}
                                        </div>
                                        <div style={{paddingRight: 10}} className={"text-end flex-fill"}>
                                            <label className="switch">
                                                <input
                                                    className="profit-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    checked={selectedHorses[key]?.no === horse.no}
                                                    onChange={() => {
                                                        setSelectedHorses((prev: any) => ({...prev, [key]: horse}));
                                                    }}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function LegCard({leg, run, winners, colClass, showOdds}: {
    leg: NormalizedLeg; run: any; winners: Set<string> | null; colClass: string; showOdds: boolean;
}) {
    const isFinished = Boolean(run?.is_finished);
    const isWinner = !!(winners?.has(leg.selections[0]));
    const oddText = showOdds && leg.oddInfo?.ratio != null
        ? (leg.oddInfo.isClosing ? "KO" : Number(leg.oddInfo.ratio).toFixed(2))
        : null;
    const showAgf = !BettingTypesMap[Number(leg.betType)]?.isFob;
    return (
        <div key={leg.key} className={colClass}>
            <div className="run-no d-flex justify-content-between px-3">
                <div>
                    {leg.headerNumber}. {leg.columnLabel}
                    {leg.isCombine && leg.hippodromeLabel ? <>&nbsp;{leg.hippodromeLabel}</> : null}
                </div>
                <span className="d-flex justify-content-center">
                    {leg.isCombine ? <>{defineLegBetTypeLabel(leg.betType)}</> : null}
                    <img alt="clock" className={leg.isCombine ? "me-2 ms-2" : "me-2"} width={16} src={clockIcon}/>{" "}
                    {run?.time || ""}
                </span>
            </div>
            {leg.selections.length === 2 ? (
                <PairHorseRow
                    selections={leg.selections}
                    run={run}
                    isFinished={isFinished}
                    isWinner={isWinner}
                    isH2H={!!BettingTypesMap[Number(leg.betType)]?.isHeadToHead}
                    oddText={oddText}
                    showAgf={showAgf}
                />
            ) : (
                leg.selections.map((no: string, i: number) => (
                    <LegHorseRow
                        key={`${leg.key}-h-${i}`}
                        no={no}
                        run={run}
                        isFinished={isFinished}
                        isWinner={!!(winners?.has(no))}
                        isCombine={leg.isCombine}
                        oddText={oddText}
                        showAgf={showAgf}
                    />
                ))
            )}
        </div>
    );
}

function LegErrorBox({legKey, colClass}: { legKey: string; colClass: string }) {
    return (
        <div key={legKey} className={colClass}>
            <div className="run-no d-flex justify-content-between px-3">
                <div>Bu bacak için veri alınamadı</div>
            </div>
        </div>
    );
}

function PairHorseRow({selections, run, isFinished, isWinner, isH2H, oddText, showAgf}: {
    selections: string[]; run: any; isFinished: boolean; isWinner: boolean; isH2H: boolean;
    oddText: string | null; showAgf: boolean;
}) {
    const primaryHorse = run?.horseMap?.[selections[0]];
    const secondHorse = run?.horseMap?.[selections[1]];
    return (
        <div className="horse-no d-flex justify-content-between" style={mobileView ? {background: "var(--color-bg-white)"} : {}}>
            <div className={"text-left" + (isWinner ? " text-danger" : "")} style={{paddingLeft: 5}}>
                {isH2H ? (
                    <>
                        <span className="fw-bold">
                            <WinnerHighlightedHorseRow horse={primaryHorse} isFinished={isFinished} item={selections[0]} leg={{[selections[0]]: [selections[0]]}}/>
                        </span>
                        <span className="fw-normal text-muted mx-1">vs</span>
                        <span className="fs-7 fw-normal">
                            <WinnerHighlightedHorseRow horse={secondHorse} isFinished={isFinished} item={selections[1]} leg={{[selections[1]]: [selections[1]]}}/>
                        </span>
                    </>
                ) : (
                    <>
                        <WinnerHighlightedHorseRow horse={primaryHorse} isFinished={isFinished} item={selections[0]} leg={{[selections[0]]: [selections[0]]}}/>
                        &nbsp;-&nbsp;
                        <WinnerHighlightedHorseRow horse={secondHorse} isFinished={isFinished} item={selections[1]} leg={{[selections[1]]: [selections[1]]}}/>
                    </>
                )}
            </div>
            {showAgf ? <AGFCell horse={primaryHorse}/> : null}
            {oddText ? <div style={{paddingRight: 5}} className="text-end">Oran: <b>{oddText}</b></div> : null}
        </div>
    );
}

function LegHorseRow({no, run, isFinished, isWinner, isCombine, oddText, showAgf}: {
    no: string; run: any; isFinished: boolean; isWinner: boolean; isCombine: boolean;
    oddText: string | null; showAgf: boolean;
}) {
    const horse = run?.horseMap?.[no];
    return (
        <div className="horse-no d-flex justify-content-between" style={mobileView ? {background: "var(--color-bg-white)"} : {}}>
            <div className={"text-left" + (isWinner ? " text-danger" : "")} style={{paddingLeft: 5}}>
                {horse || isCombine ? (
                    <WinnerHighlightedHorseRow horse={horse} isFinished={isFinished} item={no} leg={{[no]: [no]}}/>
                ) : (
                    <>{Number(no) === 32 ? (mobileView ? "(S)" : "HAZIR BAHİS") : no}</>
                )}
            </div>
            {showAgf ? <AGFCell horse={horse}/> : null}
            {oddText ? <div style={{paddingRight: 5}} className="text-end">Oran: <b>{oddText}</b></div> : null}
        </div>
    );
}

function AGFCell({horse}: { horse: any }) {
    return (
        <div style={{paddingRight: 5}}>
            <span>
                {horse?.AGF1 ? `AGF: ${horse.AGF1}` : null}
                {horse?.AGF2 ? (
                    <>
                        {" "}
                        {`${horse.AGF1 != null ? "/" : "AGF:"}`} {`${horse.AGF2}`}
                    </>
                ) : null}
            </span>
        </div>
    );
}

export function WinnerHighlightedHorseRow({horse, isFinished, item, leg}: any) {
    if (!horse) {
        return <>{Number(item) === 32 ? (mobileView ? "(S)" : "HAZIR BAHİS") : item} - {leg[item]}</>;
    }
    return (
        <>
            {horse.no} - {horse.name}
            {isFinished ? (
                <>
                    {!horse.result && horse.degree === null
                        ? "(K)"
                        : horse.result
                            ? `(${horse.result})`
                            : ""}
                </>
            ) : (
                <>{horse.run_status === false ? "(K)" : ""}</>
            )}
            <GetStablemateIcon horse={horse}/>
        </>
    );
}

export function showWinnerColorInfoModal() {
    modalServiceSubject.next({
        case: "info",
        title: "Önemli Uyarı!",
        content: `<p class="text-center"> Kazançlı at renklendirmesinde sizlere daha hızlı bilgi
                    bilgilendirme amaçlıdır.
                    Bu sayfadaki renklendirme ile Merkezi Bahis Sistemi kayıtları arasında
                    bir tutarsızlık olması
                    durumunda, renklendirme bilet kazanç durumunda etki etmez ve Merkezi
                    Bahis Sistemi kayıtları
                    esas alınır.
                 </p>`,
        confirm: {
            cancel: {
                label: "Kapat",
            },
        },
    });
}

export function showMaxWinInfoModal() {
    modalServiceSubject.next({
        case: "info",
        title: "Maks. Kazanç Hakkında",
        content: `<p class="text-center"> Maks. Kazanç, biletinizdeki oranlar üzerinden hesaplanan
                    tahmini tutardır. Biletinizdeki bahislerden birinin iptal olması ya da
                    oranların güncellenmesi durumunda ödenecek tutar değişebilir. Kesin kazanç
                    tutarı, resmî sonuçların ilanıyla biletiniz sonuçlandığında belli olur.
                 </p>`,
        confirm: {
            cancel: {
                label: "Kapat",
            },
        },
    });
}

export function showExpiredTicketModal() {
    modalServiceSubject.next({
        title: "Kapanmış Bahis",
        content:
            '<div class="text-center"><p>Bu kupon artık oynanabilir değil. Farklı bir kupon yapabilir ya da yorumcularımızın diğer kuponlarını oynayabilirsiniz.</p></div>',
        confirm: {
            cancel: {
                label: "Tamam",
            },
        },
    });
}

export function defineLegBetTypeLabel(betType: any): string {
    switch (Number(betType)) {
        case 1891:
            return "Kim Geçer";
        case 1885:
            return "Sıralı İkili";
        case 1886:
            return "İlk iki";
        case 1887:
            return "İlk Üç";
        case 1888:
            return "İlk Dört";
        case 1884:
            return "İkili Bahis";
        case 1892:
            return "Favori Hariç";
        default:
            return "Ganyan";
    }
}

function replayFobTicketToBetslip(ticket: any, navigate: (path: string) => void): void {
    const rawLegs = normalizeTicketLegs(ticket);
    const legsForReplay: NormalizedLeg[] = [];
    for (let i = 0; i < rawLegs.length; i++) {
        const leg = rawLegs[i];
        const next = rawLegs[i + 1];
        if (!leg.isCombine && leg.selections.length === 1 && next && !next.isCombine
            && next.selections.length === 1 && next.card === leg.card
            && next.raceNo === leg.raceNo && next.betType === leg.betType) {
            legsForReplay.push({
                ...leg,
                selections: [leg.selections[0], next.selections[0]],
                rawSelections: [leg.rawSelections[0], next.rawSelections[0]],
            });
            i++;
            continue;
        }
        legsForReplay.push(leg);
    }
    const itemsToPlay = legsForReplay.map((leg) => {
        const legHippodrome = getAvailableHippodromes().find(
            (h: any) => `${h._date}-${h.keyword.toLowerCase()}` === leg.card
        );
        const run = legHippodrome?.runsMap[Number(leg.raceNo)];
        const legLabel = `${legHippodrome?.hippodrome ?? leg.hippodromeLabel ?? leg.card} ${leg.raceNo}. koşu`;
        if (!legHippodrome || !run) {
            throw new Error(`${legLabel} artık bültende yok.`);
        }

        const suffix = BettingTypesMap[Number(leg.betType)]?.suffix ?? '';
        const item = leg.selections.length === 2
            ? {
                hippodrome: legHippodrome,
                run,
                bettingType: leg.betType,
                oddKey: `${leg.selections[0]}-${leg.selections[1]}${suffix}`,
                horseNos: leg.selections,
            }
            : {
                hippodrome: legHippodrome,
                run,
                bettingType: leg.betType,
                oddKey: leg.rawSelections[0],
                horseNos: [leg.selections[0]],
            };

        if (BettingTypesMap[Number(leg.betType)]?.isHeadToHead
            && !(run.fob_h2h_status && run.fob_h2h && Object.keys(run.fob_h2h).length > 0)) {
            throw new Error(`${legLabel} için Kim Geçer bahsi kapandı.`);
        }

        if (!isFobItemPlayable(item)) {
            throw new Error(`${legLabel} - ${item.horseNos.join('-')} seçimi artık oynanamıyor (at koşmuyor ya da oranlar kapanmış olabilir).`);
        }
        return item;
    });

    if (itemsToPlay.length === 0) {
        throw new Error("Bu kuponun bacakları çözümlenemedi.");
    }

    FOBBetslip.clear();
    itemsToPlay.forEach((item) => FOBBetslip.add(item));
    FOBBetslip.setOptions({
        multiply: ticket.multiply,
        fobSystemSelected: Number(ticket.bet_type) === BettingTypeIds.combineSystem && ticket.system
            ? String(ticket.system).split(',').map(Number).filter((k) => Number.isFinite(k) && k >= 1 && k <= itemsToPlay.length)
            : [],
    });

    const firstHippodrome = itemsToPlay[0].hippodrome;
    navigate(`${paths.fobBetting.url}/${firstHippodrome.keyword.toLowerCase()}${firstHippodrome._id}`);
}

export function computeLegWinner(betType: number, run: any, selections: string[], positionInRace: number): Set<string> | null {
    const type = Number(betType);

    if (BettingTypesMap[type]?.isHeadToHead || BettingTypesMap[type]?.isFavoriteExcluded || !run || run.is_finished !== true) {
        return null;
    }

    if (BettingTypesMap[type]?.isFob) {
        const primaryHorse = selections[0] ? run.horseMap?.[selections[0]] : null;
        const secondHorse = selections[1] ? run.horseMap?.[selections[1]] : null;
        return computeFobLegWinner(type, run, primaryHorse, secondHorse) ? new Set(selections) : new Set();
    }

    return computeClassicLegWinnerSet(type, run, positionInRace);
}

function computeFobLegWinner(betType: any, run: any, primaryHorse: any, secondHorse: any): boolean {
    const finishers = fobFinishers(run);
    const type = Number(betType);

    if (type === 1881) {
        return !!primaryHorse && String(finishers[0]?.no) === String(primaryHorse.no);
    }
    if (type === 1884) {
        const top2 = finishers.slice(0, 2).map((h: any) => String(h.no));
        return !!primaryHorse && !!secondHorse && top2.includes(String(primaryHorse.no)) && top2.includes(String(secondHorse.no));
    }
    if (type === 1885) {
        return !!primaryHorse && !!secondHorse
            && String(finishers[0]?.no) === String(primaryHorse.no)
            && String(finishers[1]?.no) === String(secondHorse.no);
    }
    if (type === 1886 || type === 1887 || type === 1888) {
        const n = type === 1886 ? 2 : type === 1887 ? 3 : 4;
        const topN = finishers.slice(0, n).map((h: any) => String(h.no));
        return !!primaryHorse && topN.includes(String(primaryHorse.no));
    }
    return false;
}

function fobResultsSegment(betType: any, run: any): string {
    const type = Number(betType);
    if (BettingTypesMap[type]?.isHeadToHead || BettingTypesMap[type]?.isFavoriteExcluded || !run?.is_finished) {
        return "-";
    }
    const finishers = fobFinishers(run);
    const n = type === 1887 ? 3 : type === 1888 ? 4 : (type === 1884 || type === 1885 || type === 1886) ? 2 : 1;
    const winners = finishers.slice(0, n).map((h: any) => h.no);
    if (winners.length === 0) {
        return "-";
    }
    const separator = BettingTypesMap[type]?.isFobPairPick ? runSeparator : horseSeparator;
    return winners.join(separator);
}

function computeClassicLegWinnerSet(betType: number, run: any, positionInRace: number): Set<string> | null {
    if (!run || run.is_finished !== true) {
        return null;
    }
    const type = Number(betType);
    const finishers = _.orderBy(
        (run.horses || []).filter((h: any) => h.result !== "" && h.result !== null),
        [(h: any) => Number(h.result)]
    );

    if (BettingTypesMap[type]?.winnerRule === "ordered") {
        const topN = BettingTypesMap[type]?.topNOverride;
        if (topN !== undefined) {
            return new Set(finishers.slice(0, topN).map((h: any) => String(h.no)));
        }
        const atPosition = finishers[positionInRace];
        return atPosition ? new Set([String(atPosition.no)]) : new Set();
    }

    if (BettingTypesMap[type]?.winnerRule === "set") {
        const horseCount = BettingTypesMap[type]?.horseCount ?? 1;
        return new Set(finishers.slice(0, horseCount).map((h: any) => String(h.no)));
    }

    const orderedAll = _.orderBy(
        run.horses || [],
        (h: any) => Number(h.result === "" || h.result === null ? 99999 : h.result)
    );
    if (orderedAll.length === 0) {
        return new Set();
    }
    const winners = new Set<string>();
    winners.add(String(orderedAll[0].no));
    getStableMate(orderedAll, orderedAll[0]).forEach((h: any) => winners.add(String(h.no)));

    if (String(orderedAll[0].result) === "1" && orderedAll[1] && String(orderedAll[1].result) === "1") {
        winners.add(String(orderedAll[1].no));
        getStableMate(orderedAll, orderedAll[1]).forEach((h: any) => winners.add(String(h.no)));
    }

    if (BettingTypesMap[type]?.isAGFCondition) {
        let AGF = 0;
        if (orderedAll[0].AGF_rank1 && Number(orderedAll[0].AGF_rank1) === 1) {
            AGF = 1;
        }
        if (orderedAll[0].EFG) {
            AGF = 1;
        }
        if (AGF === 1) {
            const notRunHorses = orderedAll.filter((h: any) => h.degree === null && (h.result === null || h.result === ""));
            notRunHorses.forEach((h: any) => {
                winners.add(String(h.no));
                getStableMate(orderedAll, h).forEach((s: any) => winners.add(String(s.no)));
            });
        }
        if (type === 19) {
            if (orderedAll[1]) {
                winners.add(String(orderedAll[1].no));
                getStableMate(orderedAll, orderedAll[1]).forEach((h: any) => winners.add(String(h.no)));
            }
            getStableMate(orderedAll, orderedAll[0]).forEach((h: any) => winners.add(String(h.no)));
        }
    } else if ([2, 4].includes(type)) {
        if (orderedAll[1]) {
            winners.add(String(orderedAll[1].no));
        }
    }

    return winners;
}

function classicResultsSegment(betType: number, run: any): string {
    if (!run || run.is_finished !== true) {
        return "";
    }
    const type = Number(betType);
    const finishers = _.orderBy(
        (run.horses || []).filter((h: any) => h.result !== "" && h.result !== null),
        [(h: any) => Number(h.result)]
    );
    if (BettingTypesMap[type]?.winnerRule === "ordered") {
        const topN = BettingTypesMap[type]?.topNOverride;
        if (topN !== undefined) {
            return finishers.slice(0, topN).map((h: any) => h.no).join(horseSeparator);
        }
        const column = BettingTypesMap[type]?.column ?? 1;
        return finishers.slice(0, column).map((h: any) => h.no).join(runSeparator);
    }
    if (BettingTypesMap[type]?.winnerRule === "set") {
        const horseCount = BettingTypesMap[type]?.horseCount ?? 1;
        return finishers.slice(0, horseCount).map((h: any) => h.no).join(runSeparator);
    }
    const winners = computeClassicLegWinnerSet(type, run, 0);
    return winners ? Array.from(winners).join(horseSeparator) : "";
}

function fobFinishers(run: any): any[] {
    return _.orderBy(
        (run?.horses || []).filter((h: any) => h.result !== "" && h.result !== null),
        [(h: any) => Number(h.result)]
    );
}

export const getStableMate = (horses: any, horse: any) => {
    if (horse.stablemate && Number(horse.stablemate) > 0) {
        return horses.filter((e: any) => Number(e.stablemate) === Number(horse.stablemate));
    }
    return [];
};

export type NormalizedLeg = {
    key: string;
    card: string;
    cardId: any;
    raceNo: number;
    betType: number;
    positionInRace: number;
    headerNumber: number;
    columnLabel: string;
    selections: string[];
    pairSelections?: string[];
    rawSelections: string[];
    isCombine: boolean;
    hippodromeLabel?: string;
    oddInfo?: { ratio: string; isClosing: boolean };
};

const stripLegSuffix = (v: any): string =>
    v.toString().replaceAll('EX', '').replaceAll('H2H', '').replaceAll('T2', '').replaceAll('T3', '').replaceAll('T4', '').replaceAll('WW', '');

const stripPairJoinSuffix = (v: any): string => v.toString().replaceAll('EX', '').replaceAll('H2H', '');

// Biletin oranı: önce sunucunun `fob_odd_ratio`su, o yoksa BACAK SATIRLARINDAN çarpım.
// KAYITLI kuponlarda sunucu toplam oranı hesaplamıyor - alan hep 1 geliyor - ama satırlar
// oynama anındaki gerçek oranı taşıyor (`fob.service.ts` her satıra `odd_ratio` +
// `is_closing_odd` yazıyor). Hiç satır yoksa uydurulacak bir sayı da yok: "-".
// `hasClosing`: bacaklardan biri kapanış oranlı (KO); o bacak çarpıma girmediği için
// gösterilen rakam EKSİKTİR ve yanına "+ KO" konur.
export const ticketOdds = (ticket: any): { total: number | null; hasClosing: boolean; hasRows: boolean } => {
    const rows: any[] = Array.isArray(ticket?.rows) ? ticket.rows : [];
    let product = 1;
    let known = 0;
    let hasClosing = false;
    for (const row of rows) {
        const ratio = Number(row?.odd_ratio);
        if (row?.is_closing_odd === true || !ratio || ratio === 1) {
            hasClosing = true;
            continue;
        }
        product *= ratio;
        known += 1;
    }
    const serverTotal = Number(ticket?.fob_odd_ratio);
    return {
        total: serverTotal > 1 ? serverTotal : (known > 0 ? product : null),
        hasClosing,
        hasRows: rows.length > 0,
    };
};

// Sistemli kuponun azami kazancı: seçilen her k için TÜM k'lı kombinasyonların çarpım
// TOPLAMI (elemanter simetrik polinom, e_k) × misli - kupon ekranındaki Maks. Kazanç ile
// aynı sayı. Kapanış oranlı (KO) bacak, kupon ekranındaki gibi 1 sayılır.
export const ticketSystemMaxWin = (ticket: any): number | null => {
    const rows: any[] = Array.isArray(ticket?.rows) ? ticket.rows : [];
    if (rows.length === 0) {
        return null;
    }
    const odds = rows.map((row: any) => {
        const ratio = Number(row?.odd_ratio);
        return (row?.is_closing_odd === true || !ratio) ? 1 : ratio;
    });
    const sizes = String(ticket.system ?? "").split(",")
        .map(Number)
        .filter((k: number) => Number.isFinite(k) && k >= 1 && k <= odds.length);
    if (sizes.length === 0) {
        return null;
    }
    const maxK = Math.max(...sizes);
    const e = new Array(maxK + 1).fill(0);
    e[0] = 1;
    for (const odd of odds) {
        for (let j = maxK; j >= 1; j -= 1) {
            e[j] += e[j - 1] * odd;
        }
    }
    return sizes.reduce((acc: number, k: number) => acc + e[k], 0) * (Number(ticket.multiply) || 0);
};

export const ticketOddText = (ticket: any): string => {
    const {total, hasClosing, hasRows} = ticketOdds(ticket);
    if (total !== null) {
        return `${total.toFixed(2)}${hasClosing ? " + KO" : ""}`;
    }
    // Oran hiçbir yerden çıkmıyor: bütün bacaklar kapanış oranlıysa "KO", değilse "-".
    return hasRows && hasClosing ? "KO" : "-";
};

function normalizeFromRows(ticket: any): NormalizedLeg[] {
    const {isCombine, columnLabel} = getTicketClassification(ticket.bet_type);
    const rows: any[] = Array.isArray(ticket.rows) ? ticket.rows : [];

    return rows.flatMap((row: any, index: number): NormalizedLeg[] => {
        if (row?.odd_key == null) {
            console.warn(`[TicketResolve] Row ${index} of ticket ${ticket.id} is missing odd_key, skipping`, row);
            return [];
        }
        const rowInfo = BettingTypesMap[Number(row.bet_type)];
        const rowColumnLabel = rowInfo?.columnLabel || columnLabel;
        const rawValue = row.odd_key.toString();
        const rawParts = rawValue.includes('-')
            ? rawValue.replaceAll('EX', '').split('-').map(stripPairJoinSuffix)
            : [rawValue];
        const selections = rawParts.map(stripLegSuffix);
        const oddInfo = {
            ratio: row.odd_ratio,
            isClosing: !(Number(row.odd_ratio)) || Number(row.odd_ratio) === 1,
        };
        const hippodromeLabel = isCombine
            ? (row.hippodrome_name || getHippodromesMap()[rowHippodromeKeyword(row.card)]?.HIPODROM || rowHippodromeKeyword(row.card))
            : undefined;

        if (!isCombine && rowColumnLabel === "At" && !rowInfo?.isHeadToHead && selections.length === 2) {
            return [0, 1].map((pairIdx): NormalizedLeg => ({
                key: `row-${ticket.id}-${index}-${pairIdx}`,
                card: row.card,
                cardId: row.card_id,
                raceNo: Number(row.race_id),
                betType: Number(row.bet_type),
                positionInRace: pairIdx,
                headerNumber: pairIdx + 1,
                columnLabel: rowColumnLabel,
                selections: [selections[pairIdx]],
                pairSelections: selections,
                rawSelections: [rawParts[pairIdx]],
                isCombine,
                oddInfo,
            }));
        }

        return [{
            key: `row-${ticket.id}-${index}`,
            card: row.card,
            cardId: row.card_id,
            raceNo: Number(row.race_id),
            betType: Number(row.bet_type),
            positionInRace: 0,
            headerNumber: Number(row.race_id),
            columnLabel: isCombine ? "Koşu" : rowColumnLabel,
            selections,
            rawSelections: rawParts,
            isCombine,
            hippodromeLabel,
            oddInfo,
        }];
    });
}

function normalizeFromLegs(ticket: any): NormalizedLeg[] {
    const {isCombine, isPairColumn, isH2H, columnLabel} = getTicketClassification(ticket.bet_type);

    if (isCombine) {
        return ticket.legs.flatMap((leg: any, index: number): NormalizedLeg[] => {
            const legKey = Object.keys(leg || {})[0];
            if (!legKey || !leg[legKey] || leg[legKey][0] == null) {
                console.warn(`[TicketResolve] Combine leg ${index} of ticket ${ticket.id} has an unexpected shape, skipping`, leg);
                return [];
            }
            const [legCard, legRunNo, legBetType] = legKey.split('_');
            const rawValue = leg[legKey][0].toString();
            const rawParts = rawValue.includes('-')
                ? rawValue.replaceAll('EX', '').replaceAll('H2H', '').split('-').map(stripPairJoinSuffix)
                : [rawValue];
            const selections = rawParts.map(stripLegSuffix);
            const hippodromeLabel = getHippodromesMap()[rowHippodromeKeyword(legCard)]?.HIPODROM;

            return [{
                key: `combine-${ticket.id}-${index}`,
                card: legCard,
                cardId: null,
                raceNo: Number(legRunNo),
                betType: Number(legBetType),
                positionInRace: 0,
                headerNumber: Number(legRunNo),
                columnLabel: "Koşu",
                selections,
                rawSelections: rawParts,
                isCombine: true,
                hippodromeLabel,
            }];
        });
    }

    if (isH2H) {
        const flatRaw = ticket.legs.flat().map((h: any) => h.toString());
        const pairs: string[][] = [];
        for (let i = 0; i < flatRaw.length; i += 2) {
            pairs.push(flatRaw.slice(i, i + 2));
        }
        return pairs.map((pairRaw: string[], index: number): NormalizedLeg => ({
            key: `leg-${ticket.id}-h2h-${index}`,
            card: ticket.card,
            cardId: ticket.card_id,
            raceNo: Number(ticket.race_id),
            betType: Number(ticket.bet_type),
            positionInRace: index,
            headerNumber: Number(ticket.race_id),
            columnLabel,
            selections: pairRaw.map(stripLegSuffix),
            rawSelections: pairRaw,
            isCombine: false,
        }));
    }

    const pairSelections = isPairColumn
        ? ticket.legs.flat().map((h: any) => stripLegSuffix(h))
        : undefined;

    return ticket.legs.map((leg: any, index: number): NormalizedLeg => {
        const raceNo = isPairColumn ? Number(ticket.race_id) : Number(ticket.race_id) + index;
        const headerNumber = columnLabel === "Koşu" ? Number(ticket.race_id) + index : index + 1;
        const rawParts = leg.map((h: any) => h.toString());
        const selections = leg.map((h: any) => Number(h) === 32 ? '32' : stripLegSuffix(h));
        return {
            key: `leg-${ticket.id}-${index}`,
            card: ticket.card,
            cardId: ticket.card_id,
            raceNo,
            betType: Number(ticket.bet_type),
            positionInRace: index,
            headerNumber,
            columnLabel,
            selections,
            pairSelections,
            rawSelections: rawParts,
            isCombine: false,
        };
    });
}

export function normalizeTicketLegs(ticket: any): NormalizedLeg[] {
    return (Array.isArray(ticket.rows) && ticket.rows.length > 0)
        ? normalizeFromRows(ticket)
        : normalizeFromLegs(ticket);
}

export function getTicketClassification(betType: any) {
    const info = BettingTypesMap[Number(betType)];
    const isH2H = !!info?.isHeadToHead;
    const columnLabel = info?.columnLabel;
    return {
        info,
        isCombine: !!info?.isCombine,
        isLongterm: !!info?.isLongterm,
        isH2H,
        isFob: !!info?.isFob,
        columnLabel,
        isPairColumn: columnLabel === "At" || isH2H,
    };
}

export const parseCardDate = (card: string): string => {
    const digits = card.split("-")[0];
    return `${digits.substring(4, 8)}-${digits.substring(2, 4)}-${digits.substring(0, 2)}`;
};

export function rowHippodromeKeyword(card: string): string {
    return (card.split("-")[1] || "").replace("diyarbakir", "dbakir");
}

let horseSeparator = ",";
let runSeparator = "/";

async function resolveTicketLegRuns(legs: NormalizedLeg[], ticketId: any): Promise<Map<string, { run: any; error: boolean }>> {
    const {cardEntries, failedKeys, dateSet} = partitionResolvableLegs(legs);

    await ensureOfficialResults(Array.from(dateSet));

    const runsByCard = new Map<string, Record<string, any>>();
    await Promise.all(Array.from(cardEntries.entries()).map(async ([cardStr, sampleLeg]) => {
        runsByCard.set(cardStr, await resolveRunsForCard(cardStr, sampleLeg, ticketId));
    }));

    return buildResolvedLegsMap(legs, failedKeys, runsByCard, ticketId);
}

function partitionResolvableLegs(legs: NormalizedLeg[]): {
    cardEntries: Map<string, NormalizedLeg>;
    failedKeys: Set<string>;
    dateSet: Set<string>;
} {
    const cardEntries = new Map<string, NormalizedLeg>();
    const failedKeys = new Set<string>();
    const dateSet = new Set<string>();

    legs.forEach((leg) => {
        try {
            if (!leg.card || (leg.cardId == null && !leg.card.includes('-'))) {
                throw new Error("Bacakta card/cardId eksik");
            }
            const date = parseCardDate(leg.card);
            dateSet.add(date);
            if (!cardEntries.has(leg.card)) {
                cardEntries.set(leg.card, leg);
            }
        } catch (e) {
            failedKeys.add(leg.key);
        }
    });

    return {cardEntries, failedKeys, dateSet};
}

const OfficialResults: Record<string, any> = {};
const officialResultsInFlight: Record<string, Promise<void>> = {};

export const ensureOfficialResults = async (dates: string[]): Promise<void> => {
    const missingDates = Array.from(new Set(dates)).filter((d) => !OfficialResults[d]);
    if (missingDates.length === 0) {
        return;
    }
    await Promise.all(
        missingDates.map((date) => {
            if (!officialResultsInFlight[date]) {
                officialResultsInFlight[date] = (async () => {
                    let apiUrl = resultsUrlPrefix + `/${date.split("-")[2]}${date.split("-")[1]}${date.split("-")[0]}/`;
                    let api = new ApiService();
                    const result: any = await api.start("get", apiUrl, null, false);
                    if (result.status) {
                        OfficialResults[date] = result.data;
                    } else {
                        console.warn(`[TicketResolve] Fetching official results for date ${date} failed: API returned status=false`, result);
                    }
                })().catch((err) => {
                    console.warn(`[TicketResolve] Fetching official results for date ${date} threw an error`, err);
                }).finally(() => {
                    delete officialResultsInFlight[date];
                });
            }
            return officialResultsInFlight[date];
        })
    );
};

async function resolveRunsForCard(cardStr: string, sampleLeg: NormalizedLeg, ticketId: any): Promise<Record<string, any>> {
    try {
        const date = parseCardDate(cardStr);
        const cardKeyword = rowHippodromeKeyword(cardStr);
        const programDate = `${date.split('-')[2]}${date.split('-')[1]}${date.split('-')[0]}`;
        const runsByNo: Record<string, any> = {};

        const onLiveOrProgramRun = (rRun: any) => {
            rRun.is_finished = false;
            runsByNo[rRun.no] = rRun;
        };

        await resolveHippodromeForCard({
            findDaily: (h: any) => sampleLeg.cardId != null
                ? Number(h.card_id) === Number(sampleLeg.cardId)
                : h.keyword?.toLowerCase() === cardKeyword,
            onDailyRun: onLiveOrProgramRun,
            programDate,
            programCardId: sampleLeg.cardId ?? cardStr,
            programKeyword: cardKeyword,
            onProgramRun: onLiveOrProgramRun,
            officialDate: date,
            findOfficial: (el: any) => el.keyword?.toLowerCase() === cardKeyword,
            onOfficialRun: (rRun: any) => {
                const previousHorses = new Map<string, any>(
                    ((runsByNo[rRun.no]?.horses ?? []) as any[]).map((h: any) => [String(h.no), h])
                );
                runsByNo[rRun.no] = {
                    ...rRun,
                    is_finished: true,
                    horses: (rRun.horses ?? []).map((h: any) => {
                        const previous = previousHorses.get(String(h.no));
                        if (!previous) {
                            return h;
                        }
                        return {
                            ...h,
                            agf_ratio1: h.agf_ratio1 ?? previous.agf_ratio1,
                            agf_ratio2: h.agf_ratio2 ?? previous.agf_ratio2,
                            agf_sort_no1: h.agf_sort_no1 ?? previous.agf_sort_no1,
                            agf_sort_no2: h.agf_sort_no2 ?? previous.agf_sort_no2,
                        };
                    }),
                };
            },
        });

        return runsByNo;
    } catch (e) {
        console.warn(`[TicketResolve] Resolving card ${cardStr} (ticket ${ticketId}) threw an error`, e);
        return {};
    }
}

function withHorseMap(run: any): any {
    if (!run) {
        return run;
    }
    if (run.horseMap) {
        return run;
    }
    const horseMap: any = {};
    (run.horses || []).forEach((h: any) => {
        horseMap[String(h.no)] = h;
    });
    return {...run, horseMap};
}

function buildResolvedLegsMap(
    legs: NormalizedLeg[],
    failedKeys: Set<string>,
    runsByCard: Map<string, Record<string, any>>,
    ticketId: any
): Map<string, { run: any; error: boolean }> {
    const resolved = new Map<string, { run: any; error: boolean }>();
    legs.forEach((leg) => {
        if (failedKeys.has(leg.key)) {
            console.warn(`[TicketResolve] Leg skipped for ticket ${ticketId}: missing card/cardId`, leg);
            resolved.set(leg.key, {run: null, error: true});
            return;
        }
        const runsByNo = runsByCard.get(leg.card) || {};
        const run = runsByNo[leg.raceNo];
        if (!run) {
            const cardNeverResolved = Object.keys(runsByNo).length === 0;
            console.warn(
                `[TicketResolve] Race not found for ticket ${ticketId}, card=${leg.card}, raceNo=${leg.raceNo}, betType=${leg.betType} (${cardNeverResolved ? "card never resolved" : "card resolved but raceNo missing"})`,
                {availableRaceNumbers: Object.keys(runsByNo)}
            );
        }
        resolved.set(leg.key, {run: withHorseMap(run), error: !run});
    });
    return resolved;
}

export const resolveHippodromeForCard = async (params: {
    findDaily: (h: any) => boolean;
    onDailyRun: (rRun: any, hippodrome: any) => void;
    programDate: any;
    programCardId: any;
    programKeyword?: string;
    onProgramRun: (rRun: any, hippodrome: any) => void;
    officialDate: string;
    findOfficial: (el: any) => boolean;
    onOfficialRun: (rRun: any, hippodrome: any) => void;
}): Promise<any> => {
    let hippodrome = getDailyRaces().find(params.findDaily);

    if (hippodrome && hippodrome.runs) {
        for (const rRun of hippodrome.runs) {
            params.onDailyRun(rRun, hippodrome);
        }
    } else {
        hippodrome = await getRacesFromProgram(params.programDate, params.programCardId, params.programKeyword);
        if (hippodrome && hippodrome.runs) {
            for (const rRun of hippodrome.runs) {
                params.onProgramRun(rRun, hippodrome);
            }
        }
    }

    const officialResultsForDate = OfficialResults[params.officialDate];
    const officialHippodrome = officialResultsForDate?.find(params.findOfficial);
    if (officialHippodrome && officialHippodrome.runs) {
        hippodrome = officialHippodrome;
        for (const rRun of hippodrome.runs) {
            params.onOfficialRun(rRun, hippodrome);
        }
    }

    if (!hippodrome) {
        console.warn(
            `[TicketResolve] Could not resolve hippodrome from any source (live/program/official) for programDate=${params.programDate} programCardId=${params.programCardId} programKeyword=${params.programKeyword} officialDate=${params.officialDate}`,
            {officialResultsAvailableForDate: !!officialResultsForDate}
        );
    }

    return hippodrome;
};

export const getRacesFromProgram = async (date: any, card_id: any, keyword?: string): Promise<any> => {
    const data = await fetchProgramForDate(date);
    if (!data) {
        console.warn(`[TicketResolve] No program data for date ${date}, cannot look up hippodrome (card_id=${card_id}, keyword=${keyword})`);
        return null;
    }

    if (keyword) {
        const byKeyword = data.find((h: any) => h.keyword?.toLowerCase() === keyword);
        if (byKeyword) {
            return byKeyword;
        }
    }

    const byId = card_id.toString().includes('-')
        ? data.find((h: any) => h._id === card_id)
        : data.find((h: any) => h.card_id === card_id);

    if (!byId) {
        console.warn(`[TicketResolve] Hippodrome not found in program data for date ${date} (card_id=${card_id}, keyword=${keyword})`, {
            availableKeywords: data.map((h: any) => h.keyword),
            availableCardIds: data.map((h: any) => h.card_id ?? h._id),
        });
    }
    return byId || null;
};

const programResultsByDate: Record<string, any[]> = {};
const programResultsInFlight: Record<string, Promise<any[] | null>> = {};

function fetchProgramForDate(date: string): Promise<any[] | null> {
    if (programResultsByDate[date]) {
        return Promise.resolve(programResultsByDate[date]);
    }
    if (!programResultsInFlight[date]) {
        programResultsInFlight[date] = (async () => {
            const api = new ApiService();
            const result: any = await api.start("get", `${programUrlPrefix}/${date}/`, null, true);
            if (result && result.status) {
                programResultsByDate[date] = result.data;
                return result.data;
            }
            console.warn(`[TicketResolve] Fetching program data for date ${date} failed: API returned status=false`, result);
            return null;
        })().catch((err) => {
            console.warn(`[TicketResolve] Fetching program data for date ${date} threw an error`, err);
            return null;
        }).finally(() => {
            delete programResultsInFlight[date];
        });
    }
    return programResultsInFlight[date];
}
